<template>
  <div v-if="value" :id="id" class="grid-x align-justify margin-bottom-xxs" :class="{ 'heavy-sm': heavy }">
    {{ label }}
    <div>
      {{ value }}
    </div>
  </div>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    default: '',
  },
  value: {
    type: String,
    default: '',
  },
  id: {
    type: String,
    default: '',
  },
  heavy: {
    type: Boolean,
    default: false,
  },
});
</script>
